import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Category {
  name: string;
  priority: number;
  featured: boolean;
  description?: string;
  color?: string;
  icon?: string;
  isActive?: boolean;
  createdAt?: string;
  updatedAt?: string;
}

interface CategoryState {
  categories: Category[];
  error: string | null;
  selectedCategory: Category | null;
}

const initialState: CategoryState = {
  categories: [],
  error: null,
  selectedCategory: null,
};

const CategorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setCategories: (state, action: PayloadAction<Category[]>) => {
      state.categories = action.payload;
      state.error = null;
    },
    addCategory: (state, action: PayloadAction<Category>) => {
      state.categories.push(action.payload);
    },
    updateCategory: (state, action: PayloadAction<Category>) => {
      const index = state.categories.findIndex(cat => cat.name === action.payload.name);
      if (index !== -1) {
        state.categories[index] = action.payload;
      }
    },
    removeCategory: (state, action: PayloadAction<string>) => {
      state.categories = state.categories.filter(cat => cat.name !== action.payload);
    },
    setSelectedCategory: (state, action: PayloadAction<Category | null>) => {
      state.selectedCategory = action.payload;
    },
    clearCategories: (state) => {
      state.categories = [];
      state.selectedCategory = null;
      state.error = null;
    },
  },
});

export const {
  setError,
  setCategories,
  addCategory,
  updateCategory,
  removeCategory,
  setSelectedCategory,
  clearCategories,
} = CategorySlice.actions;

export default CategorySlice.reducer;
